
/**
 * 
 * This is a base table file, do not modify this file to adapt to specific requests. 
 * Create a new view and inherit from this one.
 * Modifications in this file should apply to *ALL* tables in dashboard.
 * 
 **/

import _ from 'lodash';

import { View, Model } from 'backbone';
import constants        from 'Constants.js';
import selectAllModal from 'dashboard/TablesSelectAllModal.js';
import Spinner                  from 'spin/spin';
import template  from 'dashboard/dashboard-table.ejs';
import Immutable        from 'immutable';
class BaseDashboardTableView extends View {

    initialize( opts ) {

        this.options = opts || {};
        this.template = template;

        this.events = {        
            'change select[name=maxRecords]' :'updateMaxRecords'
        };

        this.onResize();
        this.listenTo(this.model, 'change', this.render);

        this.model.set("filterText", "", {silent:true});
        
        return this;
    }

    /* EVENTS */
    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).on('resize',() => {this.resizeGrid();})
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid() {
        let grid = $(this.model.get("currentGrid").objId);
        if (grid && grid[0]) {
            let gridParentWidth = $('#gbox_' + grid[0].id).parent().width();
            grid.setGridWidth(gridParentWidth);


            if(this.model.get("tableOptions").height === "auto"){
                let windowHeight = $(window).innerHeight();
                grid.setGridHeight(windowHeight - 430);
            }
           
        }
    }

    filterTable(e, filterObj){
        const keyCode = e.code || e.key;
        if (keyCode === 'Enter' || e.keyCode === 13 || e.type === "blur") {
            
            let filter = e.currentTarget.value || filterObj.val();
            this.model.set("filterText", filter, {silent:true});
            
            this.getItemsToRender();
        }
    }

    setPaginationEvent(grid, option, event){
        const button = $(grid.pager).find(`[data-action='${option}']`);
        button.off('click').on('click', event);
    }

    setGridModel(){
        
        const table = this.model.get("tableOptions");
        const pager = $(`[data-table='${table.id}']`)[0];

        const grid = { 
            'id': table.id,
            'objId': "#" + table.id,
            'title': table.title,
            'allSelected': false, 
            'currentPage': 1, 
            'maxRecords': 100,           
            'totalItems': table.items.length, 
            'items': [...table.items],
            'pager': pager, 
            'selectedItems': Immutable.Map(),
            'totalPages': 1,
            'colModel': table.colModel,
            'colNames': table.colNames,
            'itemsOnDemand': table.getItemsOnDemand,
            'multiselect': table.multiselect,
            'filter': table.filter,
            'filterId': "#filter-" + table.id
        }
        
        this.model.set("currentGrid", grid, { silent: true });

        if(table.title && table.title !== ""){
            $("#title-" + table.id).show();
        }

        if(table.filter){
            const filter = $(grid.filterId);
            filter.attr("placeholder", "Filter by " + table.filter.tag)

            const self = this;
          
            filter.on('keyup blur', (ev)=> {
                self.filterTable(ev, filter);
            })

            filter.show();            
        }

        this.setPaginationEvent(grid, 'tbl-firstPage', (ev) => {
            grid.currentPage = 1;
            this.getItemsToRender(true);
        });

        this.setPaginationEvent(grid, 'tbl-nextPage', (ev) => {
            grid.currentPage = grid.currentPage + 1;
            this.getItemsToRender(true);
        });

        this.setPaginationEvent(grid, 'tbl-previousPage', (ev) => {
            grid.currentPage = grid.currentPage - 1;
            this.getItemsToRender(true);
        });

        this.setPaginationEvent(grid, 'tbl-lastPage', (ev) => {
            grid.currentPage = grid.totalPages;
            this.getItemsToRender(true);
        });       
    }


   loadDashboardGrid(itemsToRender){
        const table = this.model.get("tableOptions");
        const grid = this.model.get("currentGrid");

        $(grid.objId).jqGrid('GridUnload');

        const items = itemsToRender || table.items;

        const gridObject = 
        this.getGridObject({ 
            height: table.height,
            datatype: table.dataType,
            cellEdit: table.cellEdit,
            colModel: table.colModel,
            colNames: table.colNames,
            data: items,
            multiselect: table.multiselect
        }, grid);   

        $(grid.objId).jqGrid(gridObject);

        if(table.multiselect){
            this.setSelectedItem(grid, items);
        }
        
        this.resizeGrid();
    }

    onSelectRow(rowId, checked, e){     
        const grid = this.model.get("currentGrid");
        const rowData = $(grid.objId).getRowData(rowId);
        
        let selectedItems = grid.selectedItems;
        let allItems = grid.items;

        if (checked) {
            let item = allItems.filter(item =>  item["id"] === rowData["id"] );
            selectedItems = selectedItems.set(rowData["id"], item[0]);

            if(selectedItems.size === allItems.length){
                grid.allSelected = true;
                $(`#cb_${grid.id}`).prop('checked', true);
            }
        }
        else {
            grid.allSelected = false;
            selectedItems = selectedItems.delete(rowData["id"]);
        }
        
        grid.selectedItems = selectedItems;

        if(grid.multiselect){
            this.updateTitleText(grid);
        }
    }

    onSelectAll(aRowids, status, afterSelect){
        let self = this;
        const grid = this.model.get("currentGrid");
        const currentView =  this.model.get("currentView");
      
        if (grid && grid.items.length > 0) {
            let selectedItems = grid.selectedItems;

            const selectAll = new selectAllModal({
                model: new Model(),
                width: 420, height: "auto"
            });

            const setAllPage = (value, result) => {
                $('<div id="spinner-overlay"></div>').appendTo('body');
                const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
                let items = [];

                if(result === "all"){
                    items = grid.items;
                }else{
                    items = this.paginateDashboardGrid(grid);
                }

                items.forEach((item) => {
                    selectedItems = selectedItems.set(item["id"], item);
                });
                grid.selectedItems = selectedItems;
                this.updateTitleText(grid);
                $("#spinner-overlay").remove();
                spinner.stop();
            };

            if (status) {
                selectAll.render().then(result => {

                    grid.allSelected = result === "all";

                    if(result !== "canceled"){
                        if(grid.itemsOnDemand){
                            grid.itemsOnDemand(currentView, grid, this.getIndex).then(() => {
                                setAllPage(status, result);
                                if (afterSelect) {
                                    afterSelect(self, grid, result);
                                }
                            });
                        }
                        else{
                            setAllPage(status, result);
                            if (afterSelect) {
                                afterSelect(self, grid, result);
                            }
                        }
                    }else{
                        grid.selectedItems = Immutable.Map();
                        $(`#cb_${grid.id}`).trigger('click');
                        this.updateTitleText(grid);
                    }
                    

                }).catch(err => console.log(err));
            }
            else {
                grid.selectedItems = Immutable.Map();
                this.updateTitleText(grid);
                if (afterSelect) {
                    afterSelect(self, grid, '');
                }
            }
        }        
    }

    
    getGridObject(options={}, grid){

        const currentView = this.model.get("currentView");
        let defaultGridParameters = {
            shrinkToFit: true,
            autowidth: true,
            altRows: true,
            minHeight: 90,
            scrollrows: true,
            altclass:'jqGrid-alt-row',
            loadui: 'disable',
            cellsubmit : 'clientArray',

            gridComplete: () => {
                const event = currentView.gridComplete;
                if(event){
                    event();
                }

                this.setPagination();
            },
            onCellSelect: (rowid, iCol, cellcontent, e) => {
                const event = currentView.onCellSelect;
                if(event){
                    event(rowid, iCol, cellcontent, e, currentView);
                }
            },
            onSelectRow: (rowId, status, e) => {
             
                this.onSelectRow(rowId, status, e);
                
                if(currentView.onSelectRow){
                    currentView.onSelectRow(rowId, status, e, currentView);
                }
            },
            ondblClickRow: (rowId,iRow,iCol,e) => {
                const event = currentView.ondblClickRow;
                if(event){
                    event(rowId,iRow,iCol,e, currentView);
                }
            },
            beforeSelectRow: (rowId,e) => {
                const event = currentView.beforeSelectRow;
                if(event){
                    event(rowId,e, currentView);
                }
            },
            afterSaveCell: (rowId, cellName, value, iRow, iCol) => {
                const event = currentView.afterSaveCell;
                if(event){
                    event(rowId, cellName, value, iRow, iCol, currentView);
                }
            },
            afterEditCell: (rowId, cellName, value, iRow, iCol) => {
                const event = currentView.afterEditCell;

                $("#"+iRow+"_"+ cellName, grid.objId).on('blur',function(){
                    $(grid.objId).saveCell(iRow,iCol);
                  });

                if(event){
                    event(rowId, cellName, value, iRow, iCol, currentView);
                }
            },
            onSelectAll: (aRowids, status) => {
                this.onSelectAll(aRowids, status, currentView.onSelectAll);
            }
        };
        return Object.assign({}, defaultGridParameters, options);
    }

    updateTitleText(grid) {

        const selectedItems = grid.selectedItems.size;        
        let text = grid.title;
        
        if (selectedItems > 0) {
            text = `${selectedItems} out of ${grid.totalItems} ${grid.title} selected`;
        }
      
        this.$el.find('h2[name="tableTitle"]').text(text);
    }

    filterItems(grid, itemsToRender){

        let filteredItems = itemsToRender;
        const filterValue = this.model.get("filterText").toLowerCase();

        if (grid.filter && (filterValue && filterValue.length > 0)) {  
            
            const filterBy = (str) => itemsToRender.filter(
                item => item[grid.filter.columnId].toLowerCase().indexOf(str) >= 0
            );
            
            //PF-8675 Filter by wildcard in case it is specified
            // const filterBy = (str) => itemsToRender.filter(
            //     item => new RegExp('^' + str.replace(/\*/g, '.*') + '$').test(item[grid.filter.columnId].toLowerCase())
            // );
            
            filteredItems = filterBy(filterValue);
        }

        return filteredItems;
    }
    

    getItemsToRender (fromPagination){
        const currentView = this.model.get("currentView");
        const grid = this.model.get("currentGrid");
        
        if(grid.itemsOnDemand){
            grid.itemsOnDemand(currentView, grid, this.getIndex, fromPagination).then(() => {
                let itemsToRender = this.filterItems(grid, this.model.get("currentGrid").items);
                this.loadDashboardGrid(itemsToRender); 
            });
        }
        else{
            let itemsToRender = this.filterItems(grid, grid.items);
            itemsToRender = this.paginateDashboardGrid(grid, itemsToRender);
            this.loadDashboardGrid(itemsToRender); 
        }
    }

    setSelectedItem(grid, items){

        let selectedItems = grid.selectedItems;
        const isChecked = document.getElementById(`cb_${grid.id}`).checked;
      
        if(!isChecked){
            items.forEach(item => {
                if(selectedItems.get(item["id"])){
                    $(grid.objId).jqGrid('setSelection', item['id'], false);          
                }
            });

            if(grid.allSelected){
                $(`#cb_${grid.id}`).prop('checked', true);
            }
        }
    }

    setPagination(){
        const grid = this.model.get("currentGrid");

        const items = grid.items || 0,
         maxRecords = grid.maxRecords,
         currentPage = grid.currentPage,
         totalPages = Math.ceil(grid.totalItems / maxRecords),
         pagination = 'Page ' + currentPage + ' of ' + totalPages,
         
         pager = $(grid.pager),         
         paginationObject = pager.find('.pagination-text'),
         
         first = $(grid.pager).find('[data-action=tbl-firstPage]'),
         next =  $(grid.pager).find('[data-action=tbl-nextPage]'),
         prev =  $(grid.pager).find('[data-action=tbl-previousPage]'),
         last =  $(grid.pager).find('[data-action=tbl-lastPage]');

         $(grid.pager).find('.dashTbl-icon').prop('disabled', true);

         //Enable pagination
         if (totalPages > 1) {
            if (currentPage !== totalPages) {
                last.prop('disabled', false);
                next.prop('disabled', false);
            }

            if (currentPage > 1) {
                first.prop('disabled', false);
                prev.prop('disabled', false);
            }
        }
        
        grid.totalPages = totalPages;

        paginationObject.text(pagination);

        if(items.length > 0){
            pager.show();
        }   
        else{
            pager.hide();
        }    
    }

    updateMaxRecords(ev){
        let maxRecords = ev.currentTarget.value;
        let currentGridId = ev.currentTarget.dataset.table;
      
        let grid = this.model.get("currentGrid");
        grid.maxRecords = maxRecords;   

        this.cleanGrid(currentGridId);
        this.getItemsToRender(false);
    }

    paginateDashboardGrid(grid, gridItems){
        let items = gridItems;
        const index = this.getIndex(grid);
      
        if(!grid.itemsOnDemand){    
            grid.totalItems = items.length;        
            items = items.slice(index.start, index.end);            
        }       

        return items;
    }

    getIndex(grid) {      
        const   pageSize = grid.maxRecords,
                pageNumber = grid.currentPage,
                startIndex = (pageNumber - 1) * pageSize, 
                endIndex = pageNumber * pageSize;

        return {'start': startIndex, 'end': endIndex};
    }


    cleanGrid(gridId){

        const grid = this.model.get("currentGrid");
        grid.allSelected = false;
        grid.currentPage = 1;
        grid.totalItems = 0;
        grid.selectedItems = Immutable.Map();
        grid.totalPages = 1;
       
    }


    render() {
        
        const html = this.template( this.model.toJSON() );
        this.$el.html(html);

        this.setGridModel();
        this.loadDashboardGrid();
        this.delegateEvents();
        
        return this;
    }

}

export default BaseDashboardTableView;